import { LitElement, css, html } from 'lit';

import { customElement } from 'lit/decorators';

@customElement('admin-blog-to-map-ai-addon')
export class BlogToMapAIAddon extends LitElement {

    openExtension() {
        window.open('https://chrome.google.com/webstore/detail/proxi/kambmamfjckgbcneopcmbemlmikcnalb', '_blank');
    }

    render() {
        return html`
            <div class="addon__container">
                <ul class="info-paragraph">
                    <li>Engaging Content: Transform your blog post into an interactive, embeddable map that grabs attention and keeps readers hooked, resulting in increased time spent on your page.</li>
                    <li>Speed and Ease: AI quickly converts your existing content into a captivating Proxi map, eliminating the need to start from scratch.</li>
                </ul>

            <h4 class="sub-title">How to Use Map My Blog Extension:</h4>
                <ol class="info-paragraph">
                    <li>Install - Install the extension, pin it to your browser, and click the icon to log in.</li>
                    <li>Go to your site - Navigate to the blog or site that you want to map.</li>
                    <li>Capture - Click the extension button to have Proxi scan your blog or website and select points with Map My Blog</li>
                    <li>Edit - Refine your map and add your brand's personal touch within Proxi's no-code tool</li>
                    <li>Publish - Easily embed your map on your blog page and share your map link anywhere!</li>
                </ol>
            </div>
            <div class="addon__footer">
                <mwc-button @click="${this.openExtension}" raised>Install Extension</mwc-button>
            </div>
            <error-toast id="errorToast"></error-toast>
		`;
    }

    static get styles() {
        return css`
            .addon__container {
                flex-direction: column;
                max-height: calc(100vh - 90px);
                overflow: hidden auto;
                margin-bottom: 1rem;
                padding-right: 30px;
            }

            /* width */
            .addon__container::-webkit-scrollbar {
                width: 5px;
            }

            /* Track */
            .addon__container::-webkit-scrollbar-track {
                background: var(--theme-light-scrollbar-color);
            }

            /* Handle */
            .addon__container::-webkit-scrollbar-thumb {
                background: var(--main-moon-color);
            }

            .drawer_image {
                margin-top: 1rem;
                margin-bottom: 1rem;
            }

            .title {
                color: var(--main-primary-color);
                text-align: center;
                font-size: 18px;
                font-weight: 700;
                line-height: 130%;
                margin: 5px 0;
                text-align: left;
            }

            .info-paragraph {
                color: var(--theme-input-color);
                margin-top: 0;
                margin-bottom: 0;
            }

            .sub-title {
                margin-bottom: 5px;
                color: var(--theme-input-color);
            }

            .addon__footer {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
                padding: 0 20px;
                gap: 10px;
            }
        `;
    }
}